import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Modal, TextField, Button } from "@mui/material";
import { useQuantityContext } from "../QuantityContext";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import LockIcon from "@mui/icons-material/Lock";
import DeleteIcon from '@mui/icons-material/Delete';

function Notes() {
  const [notes, setNotes] = useState([]);
  const [newFolderModal, setNewFolderModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    title: "",
    note: "",
    description: "",
    folder_id: "",
  });

  const { id } = useParams();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    let tempErrors = {};
    if (!formData.title) tempErrors.title = "Title is required";
    if (!formData.note) tempErrors.note = "Note is required";
    if (!formData.description)
      tempErrors.description = "Description is required";
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      console.log(formData);

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/notes`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("objectId")}`,
          },
          body: JSON.stringify({ ...formData, folder_id: id }),
        }
      );

      const data = await response.json();

      if (data.statusCode === 200) {
        openSnackbar("Note added successfully", "success");
        fetchNotes();
      } else {
        openSnackbar("Error in adding note", "error");
      }

      setNewFolderModal(false);
      setFormData({
        title: "",
        note: "",
        description: "",
        folder_id: "",
      });
    } else {
      console.log("Invalid form");
    }
  };

  const { openSnackbar } = useQuantityContext();

  const fetchNotes = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/notes?folderId=${id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("objectId")}`,
        },
      }
    );

    const data = await response.json();
    if (data.statusCode === 200) {
      setNotes(data.data.notes);
    } else {
      openSnackbar(data.message, "error");
    }
  };

  const handleNoteDelete = (deletedNoteId) => {
    setNotes(prevNotes => prevNotes.filter(note => note.id != deletedNoteId));
  }

  useEffect(() => {
    fetchNotes();
  }, [id]);

  return (
    <div
      className="d-flex align-items-start gap-4 p-4 home-page-container"
      style={{
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          minWidth: "90vw",
          minHeight: "100vh",
          backgroundColor: "white",
          padding: "2rem",
        }}
      >
        <h3 className="fw-semibold">All Secured Notes</h3>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "1rem",
            marginTop: "1rem",
          }}
        >
          {notes.map((note) => (
            <NoteBox
              key={note.id}
              note={note}
              onDelete={handleNoteDelete}
            />
          ))}
        </div>
      </div>

      {/* <Fab
        color="primary"
        aria-label="add"
        sx={{
          position: "fixed",
          bottom: 50,
          right: 80,
          background: "#ffffff",
          '&:hover': {
            background: "#ffffff", // Set same as normal background to remove hover effect
          },
        }}
        onClick={() => setNewFolderModal(true)}
      >
        <AddIcon style={{ color: "#0044c6" }} />
      </Fab> */}

      <Fab
        color="primary"
        aria-label="add"
        sx={{
          position: "fixed",
          bottom: 50,
          right: 80,
          background: "#ffffff",
          '&:hover': {
            background: "#ffffff", // Set same as normal background to remove hover effect
          },
        }}
        onClick={() => setNewFolderModal(true)}
      >
        <AddIcon style={{ color: "#0044c6" }} />
      </Fab>

      <Modal
        open={newFolderModal}
        onClose={() => setNewFolderModal(false)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(0,0,0,0.3)",
        }}
      >
        <Box
          className="modal-box-1"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
            width: "40%",
            height: "50%",
            backgroundColor: "white",
            paddingLeft: "8rem",
            paddingRight: "8rem",
          }}
        >
          <h3
            style={{
              margin: "0",
              padding: "0",
              fontWeight: "900",
              fontSize: "24px",
            }}
          >
            Add New Note
          </h3>
          <form style={{ width: "100%", padding: "0 2rem" }}>
            <TextField
              label="Title"
              variant="outlined"
              fullWidth
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              error={!!errors.title}
              helperText={errors.title}
              style={{ marginBottom: "1rem" }}
            />
            <TextField
              label="Description"
              variant="outlined"
              fullWidth
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              error={!!errors.description}
              helperText={errors.description}
              style={{ marginBottom: "1rem" }}
            />
            <TextField
              label="Secure Note"
              variant="outlined"
              fullWidth
              name="note"
              value={formData.note}
              onChange={handleInputChange}
              error={!!errors.note}
              helperText={errors.note}
              style={{ marginBottom: "1rem" }}
            />
            <Button
              onClick={handleSubmit}
              variant="contained"
              color="primary"
              type="button"
              fullWidth
              sx={{ backgroundColor: "#0044c6" }}
            >
              Submit
            </Button>
          </form>
        </Box>
      </Modal>
    </div>
  );
}

export default Notes;

const generateRandomRgba = () => {
  const r = Math.floor(Math.random() * 256); // Random value for red (0-255)
  const g = Math.floor(Math.random() * 256); // Random value for green (0-255)
  const b = Math.floor(Math.random() * 256); // Random value for blue (0-255)

  return `rgba(${r}, ${g}, ${b}, 0.3)`;
};

const NoteBox = ({ note, onDelete }) => {
  const [type, setType] = useState("");
  const [password, setPassword] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [otpModal, setOtpModal] = useState(false);
  const [bgColor] = useState(generateRandomRgba());
  const [noteText, setNoteText] = useState("");
  const [isHovered, setIsHovered] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);


  const folder_id = useParams().id;

  const { openSnackbar } = useQuantityContext();

  const handleNoteClick = () => {
    setShowModal(true);
    setNoteText(""); // Reset note text when opening the modal
  };

  const handleDeleteClick = async (e) => {
    e.stopPropagation();
    setShowDeleteModal(true);
  }

  const confirmDelete = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/notes/${note.id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("objectId")}`
          }
        }
      );
      const data = await response.json();

      if (data.message == "Note deleted successfully") {
        openSnackbar("Note deleted successfully", "success");
        setShowDeleteModal(false);
        if (onDelete) {
          onDelete(note.id);
        }
      }
      else {
        openSnackbar(data.message || "Failer to delete note", "error");
      }
    } catch (err) {
      console.log("error --> ", err.message);
      openSnackbar("Error deleting note", "error");
    }
  }

  const cancelDelete = () => {
    setShowDeleteModal(false);
  }

  const sendOtp = async (type) => {
    setType(type);
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/v1/folders/otp?type=${type}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("objectId")}`,
        },
      }
    );
    const data = await response.json();

    if (data.statusCode === 200) {
      openSnackbar("OTP sent successfully", "success");
    }
    setShowModal(false);
    setOtpModal(true);
  };

  const handleVerify = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/v1/folders/otp`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("objectId")}`,
        },
        body: JSON.stringify({
          method: type,
          folder_id: folder_id,
          pin: Number(password),
        }),
      }
    );

    const data = await response.json();

    if (data.statusCode === 200) {
      setShowModal(false);
      setPassword("");
      openSnackbar("Authenticated successfully", "success");
      getNote();
    } else {
      openSnackbar("Invalid OTP or PIN", "error");
    }
  };

  const getNote = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/notes/${note.id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("objectId")}`,
        },
      }
    );

    const data = await response.json();
    if (data.statusCode === 200) {
      setNoteText(data.data.note);
    } else {
      openSnackbar(data.message, "error");
    }
  };

  return (
    <>
      <div
        className="person-box"
        style={{
          textAlign: "left",
          height: "144px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          backgroundColor: bgColor,
          position: "relative",
          cursor: "pointer"
        }}
        onClick={handleNoteClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <LockIcon
          style={{
            width: "20px",
            height: "20px",
          }}
        />
        {isHovered && (
          <div
            style={{
              position: "absolute",
              top: "8px",
              right: "8px",
              cursor: "pointer",
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              borderRadius: "50%",
              padding: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s ease",
            }}
            onClick={handleDeleteClick}
          >
            <DeleteIcon
              style={{
                width: "16px",
                height: "16px",
                color: "#f44336",
              }}
            />
          </div>
        )}
        <div>
          <p
            style={{
              margin: "0",
              padding: "0",
              fontWeight: "900",
            }}
          >
            {note.title}
          </p>
          <span
            style={{
              display: "block",
              fontSize: "11px",
              fontWeight: "200",
            }}
          >
            {note.description}
          </span>
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
          setPassword("");
          setNoteText("");
        }}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(0,0,0,0.1)",
        }}
      >
        <Box
          className="modal-box-1 px-5 py-3"
          style={{
            backgroundColor: "white",
          }}
        >
          <p className="fw-semibold text-center px-2">Choose the option below to access your secured notes on {note.title}.</p>
          <div className="text-center fw-semibold" style={{ color: "#666666", }}>
            {note.title}
          </div>
          <div className="text-center py-2" style={{ color: "#333" }}>
            {note.description}
          </div>

          <Box className="d-flex flex-column justify-content-center align-items-center gap-2">
            <Button
              variant="contained"
              color="primary"
              style={{
                width: "200px",
                backgroundColor: "#0044c6"
              }}
              onClick={() => sendOtp("phone")}
            >
              SEND OTP VIA PHONE
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{
                width: "200px",
                backgroundColor: "#0044c6"
              }}
              onClick={() => sendOtp("email")}
            >
              SEND OTP VIA EMAIL
            </Button>
          </Box>

        </Box>
      </Modal>

      <Modal
        open={otpModal}
        onClose={() => {
          setOtpModal(false);
          setShowModal(false);
          setPassword("");
          setNoteText("");
        }}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(0,0,0,0.3)",
        }}
      >
        <Box
          className="modal-box-1 px-5 py-4"
          style={{
            backgroundColor: "white",
            padding: "2rem",
          }}
        >
          {noteText ? <p className="fw-semibold">The secured notes saved on {note.title}.</p> : <p className="fw-semibold">Please enter the OTP you received to verify your identity.</p>}
          {noteText ? "" :
            <>
              <div className="text-center fw-normal" style={{ color: "#666666" }}>
                {note.title}
              </div>
              <p className="text-center" style={{ color: "#666666" }}>
                {note.description}
              </p>

            </>}

          {!noteText && (
            <div className="justify-content-center align-items-center"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
              }}
            >
              <TextField
                label="Enter OTP"
                variant="outlined"
                style={{
                  width: "200px",
                }}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <Button
                variant="contained"
                color="primary"
                style={{
                  width: "200px", background: "#0044c6"
                }}
                onClick={handleVerify}
              >
                Submit
              </Button>
            </div>
          )}
          {noteText && <div>{noteText}</div>}
        </Box>
      </Modal>
      <Modal
        open={showDeleteModal}
        onClose={cancelDelete}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
      >
        <Box
          className="modal-box-1"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "1.5rem",
            width: "400px",
            backgroundColor: "white",
            padding: "2rem",
            borderRadius: "8px",
          }}
        >
          <h3
            style={{
              margin: "0",
              padding: "0",
              fontWeight: "600",
              fontSize: "20px",
              color: "#333",
              textAlign: "center",
            }}
          >
            Delete Note
          </h3>
          <p
            style={{
              margin: "0",
              padding: "0",
              fontWeight: "400",
              color: "#666",
              textAlign: "center",
              lineHeight: "1.5",
            }}
          >
            Are you sure you want to delete "{note.title}"? This action cannot be undone.
          </p>
          <div
            style={{
              display: "flex",
              gap: "1rem",
              width: "100%",
              justifyContent: "center",
            }}
          >
            <Button
              variant="outlined"
              style={{
                width: "120px",
                borderColor: "#ccc",
                color: "#666",
              }}
              onClick={cancelDelete}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              style={{
                width: "120px",
                backgroundColor: "#f44336",
                color: "white",
              }}
              onClick={confirmDelete}
            >
              Yes, Delete
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
};
